import React from 'react';

const InspectionServiceSection = ({ data }) => {
    return (
        <section className="inspections-service">
            <div className="container">
                <div className="inner-content">
                    <div className="content-wrapper">
                        <div className="top-row">
                            <div className="left-wrap">
                                <img src={data.image} alt="Inspection Service" />
                            </div>
                            <div className="right-wrapper">
                                <p>{data.description}</p>
                            </div>
                        </div>

                        <div className="bottom-wrapper">
                            {data.subtitle && <h5>{data.subtitle}</h5>}
                            <h6>{data.title}</h6>
                            <ul>
                                {data.checklist.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InspectionServiceSection;
